<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="12">
                        <div class="banner-title">{{$t('challengeList.title')}}</div>
                    </van-col>
                    <van-col span="6" @click="toHistory">
                        <div class="history">
                            {{$t('challengeList.history')}}
                        </div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="list">
            <div class="c-box" v-for="item in info" :key="item.challengeId" @click="toDesc(item)">
                <div class="icon-box">
                    <img class="c-icon" v-if="item.attribute != 0"
                         :src="require(`@/assets/theme/light/sport/01challengeList/0${item.attribute}img.png`)">
                    <img class="c-icon" v-if="item.attribute == 0"
                         :src="item.banner">
                </div>
                <div class="c-title">{{getName(item)}}</div>
                <div class="c-time">{{item.startDate.slice(5, 10).replace(/-/g, '/')}}-{{item.endDate.slice(5, 10).replace(/-/g, '/')}}</div>
                <div v-if="item.userChallengeId">
                    <div v-if="item.stage == 1">
                        <img class="time-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/05time.svg`)">
                        <div class="c-countdown" v-if="$i18n.locale == 'zh'">还剩<span
                                class="c-light"> {{getDistanceDays(new Date(), item.endDate)}} </span>天
                        </div>
                        <div class="c-countdown" v-if="$i18n.locale == 'en'">
                            <span class="c-light">{{getDistanceDays(new Date(), item.endDate)}}</span> days left
                        </div>
                        <img class="rank-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/06rank.svg`)">
                        <div class="c-rank" v-if="$i18n.locale == 'zh'">第<span class="c-light"> {{item.rank ? item.rank : '--'}} </span>名</div>
                        <div class="c-rank" v-if="$i18n.locale == 'en'">No.<span class="c-light"> {{item.rank ? item.rank : '--'}} </span></div>
                    </div>
                    <div v-if="$i18n.locale == 'zh'">
                        <img class="info-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/07info.svg`)">
                        <div class="c-info" v-if="item.attribute == 0">剩余距离：<span class="c-light"> {{((item.target - item.totalData) / 100000).toFixed(2)}} </span>公里
                        </div>
                        <div class="c-info" v-if="item.attribute == 1">当前距离：<span class="c-light"> {{item.totalData ? (item.totalData / 100000).toFixed(2) : '--' }} </span>公里
                        </div>
                        <div class="c-info" v-if="item.attribute == 2">卡路里：<span class="c-light"> {{item.totalData ? (item.totalData / 1000).toFixed(2) : '--' }} </span>千卡
                        </div>
                        <div class="c-info" v-if="item.attribute == 3">最快配速：<span class="c-light">{{item.totalData ? formatSeconds(item.totalData) : '--'}} </span>/公里
                        </div>
                        <div class="c-info" v-if="item.attribute == 4">当前步数：<span class="c-light">{{item.totalData ? item.totalData : '--'}} </span>步
                        </div>
                    </div>
                    <div v-if="$i18n.locale == 'en'">
                        <img class="info-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/07info.svg`)">
                        <div class="c-info" v-if="item.attribute == 0">Remaining distance：<span class="c-light">{{((item.target - item.totalData) / 100000).toFixed(2)}} </span>KM
                        </div>
                        <div class="c-info" v-if="item.attribute == 1">Current distance：<span class="c-light">{{item.totalData ? (item.totalData / 100000).toFixed(2) : '--' }} </span>KM
                        </div>
                        <div class="c-info" v-if="item.attribute == 2">Calorie：<span class="c-light">{{item.totalData ? (item.totalData / 1000).toFixed(2) : '--' }} </span>Kcal
                        </div>
                        <div class="c-info" v-if="item.attribute == 3">Fastest pace：<span class="c-light">{{item.totalData ? formatSeconds(item.totalData) : '--'}} </span>/KM
                        </div>
                        <div class="c-info" v-if="item.attribute == 4">Current Steps：<span class="c-light">{{item.totalData ? item.totalData : '--'}}</span>
                        </div>
                    </div>
                </div>
                <div v-if="!item.userChallengeId">
                    <img class="info-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/08info.svg`)">
                    <div class="c-info">{{$t('challengeList.join')}}：<span class="c-light">{{item.participantNum}}</span>
                    </div>
                    <img class="join-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/09join.svg`)">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {getDistanceDays, formatSeconds} from '@/utils/dateUtils'
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'challengeList',
        data() {
            return {
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                info: [],
            }
        },
        mounted() {
            document.documentElement.setAttribute("theme", this.theme)
            if (getQueryVariable("token")) {
                localStorage.setItem("token", getQueryVariable("token"));
            }
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            toHistory() {
                this.$router.push({
                    name: 'challengeHistory',
                    query: {
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            },
            getData() {
                this.$api.sport.getChallengeList({
                    pageNum: 1,
                    pageSize: 300,
                    type: 0,
                }).then(res => {
                    this.info = res.info.items
                })
            },
            getDistanceDays(date1, date2) {
                return getDistanceDays(date1, date2)
            },
            formatSeconds(num) {
                return formatSeconds(num)
            },
            toDesc(item) {
                this.$router.push({
                    name: 'challengeDesc',
                    query: {
                        challengeId: item.challengeId,
                        userChallengeId: item.userChallengeId,
                        userId: this.userId,
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            },
            // 获取挑战赛名称
            getName(challenge) {
                if (challenge.attribute == 0) {
                    return this.$t('challengeType.attribute0.name')
                } else {
                    let monthNum = parseInt(challenge.name) - 1;
                    let monthDesc = this.$t('monthArr['+monthNum+']');
                    let name;
                    if (challenge.name.indexOf('骑行') != -1) {
                        name = this.$t('challengeType.attribute'+challenge.attribute+'骑行.name');
                    } else if (challenge.name.indexOf('跑步') != -1) {
                        name = this.$t('challengeType.attribute'+challenge.attribute+'跑步.name');
                    } else {
                        name = this.$t('challengeType.attribute'+challenge.attribute+'.name');
                    }
                    if (this.$i18n.locale === 'zh') {
                        return monthDesc+name;
                    } else {
                        return monthDesc+" "+name;
                    }
                }

            }
        }
    }
</script>

<style scoped>
    .list {
        margin-top: 98px;
    }

    .c-box {
        width: 345px;
        height: 126px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 10px auto;
        position: relative;
    }

    .icon-box {
        width: 86px;
        height: 88px;
        background: linear-gradient( 179deg, #E9FFF8 0%, #FFFFFF 100%);
        border-radius: 10px 10px 10px 10px;
        position: absolute;
        top: 21px;
        left: 16px;
    }

    .c-icon {
        height: 88px;
        float: right;
    }

    .c-title {
        font-size: 17px;
        color: var(--text-color-1);
        position: absolute;
        left: 115px;
        top: 21px;
    }

    .c-time {
        font-size: 12px;
        color: var(--text-color-3);
        position: absolute;
        left: 115px;
        top: 44px;
    }

    .time-icon {
        width: 16px;
        position: absolute;
        left: 115px;
        top: 66px;
    }

    .c-countdown {
        font-size: 15px;
        color: var(--text-color-1);
        position: absolute;
        left: 137px;
        top: 67px;
        line-height: 15px;
    }

    .c-light {
        color: var(--chart-color-1);
    }

    .rank-icon {
        width: 16px;
        position: absolute;
        left: 240px;
        top: 66px;
    }

    .c-rank {
        font-size: 15px;
        color: var(--text-color-1);
        position: absolute;
        left: 262px;
        top: 67px;
        line-height: 15px;
    }

    .info-icon {
        width: 16px;
        position: absolute;
        left: 115px;
        top: 92px;
    }

    .c-info {
        font-size: 15px;
        color: var(--text-color-1);
        position: absolute;
        left: 137px;
        top: 93px;
        line-height: 15px;
    }

    .join-icon {
        width: 38px;
        position: absolute;
        left: 277px;
        top: 72px;
    }

    .history {
        font-size: 15px;
        color: var(--chart-color-1);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 20px;
        height: 44px;
    }
</style>



// WEBPACK FOOTER //
// src/views/sport/01challengeList.vue